import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';

const PAGE_OF_TASK_ROLE_ASSIGNMENTS_QUERY = gql`
  query GetPageOfTaskRoleAssignmentsForSelector(
    $taskId: String!
    $page: Int!
    $pageSize: Int!
    $filter: TaskRoleAssignmentFilter
  ) {
    task(taskId: $taskId) {
      id
      taskRoleAssignments(page: $page, pageSize: $pageSize, filter: $filter) {
        roleAssignments {
          projectRole {
            id
            displayText
          }
          isDefault
        }
      }
    }
  }
`;

const usePageOfTaskRoleAssignments = ({
  taskUri,
  page,
  pageSize,
  textSearch,
  skip = false
}) => {
  const { data, loading } = useQuery(PAGE_OF_TASK_ROLE_ASSIGNMENTS_QUERY, {
    variables: {
      taskId: taskUri,
      page,
      pageSize,
      filter: textSearch ? { textSearch } : null
    },
    skip: skip || !taskUri,
    fetchPolicy: 'cache-and-network'
  });

  const roleAssignments = data?.task?.taskRoleAssignments?.roleAssignments;

  const roles = useMemo(
    () =>
      (roleAssignments ?? []).map(({ projectRole }) => ({
        roleUri: projectRole.id,
        displayText: projectRole.displayText,
        isAssigned: true
      })),
    [roleAssignments]
  );

  return {
    roles,
    hasMore: roles.length === pageSize,
    loading
  };
};

export default usePageOfTaskRoleAssignments;
